import React, { Component } from 'react';
import _ from 'underscore';
import { Button } from 'react-bootstrap';
import { mixinsClassName, fetch, urls, guid, isImg, sendAliBase64 } from '../utils';
import { Toolbar, Footbar } from '../ui/base';
import { Uploader, ImgThumbPreview, Capture } from '../ui';

export default class extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pickFlag: false,
            imgThumbPreviewSrc: '',
            isShowImgThumbPreview: false,
            fnCancelThumbImg: null,
            fnSubmitThumbImg: null
        }
    }
    noBubble(ev) {
        ev.stopPropagation();
    }

    findMsgByFile(file_id) {
        const { session, msgData } = this.props;

        return _.find(msgData, item => item.body.session_id === session.id && item.body.file_id === file_id);
    }

    createMsg(obj) {
        const { user, session } = this.props;

        let message_id = obj.message_id || guid();

        return _.extend({
            message_id: message_id,
            from: user.jid,
            to: session.jid,
            session_id: session.id
        }, obj, {
            body: _.extend({
                type: 'text',
                user_jid: user.jid,
                session_id: session.id,
                message_id
            }, obj.body)
        });
    }

    async sendMsg(msgOrbody, cfg) {
        const { user, session, actions, onWillSendMsg, onDidSendMsg } = this.props;

        let msg;

        cfg = cfg || {};
        if (_.isObject(msgOrbody.body)) {
            msg = msgOrbody;
        } else {
            msg = { body: msgOrbody };
        }

        msg.status = 'loading';
        msg = this.createMsg(msg);
        onWillSendMsg && onWillSendMsg(msg, session);
        actions.addOrEdit(msg);

        let res = await fetch(urls.api.msg.save, {
            method: 'post',
            data: _.omit(msg, 'status', 'status_msg')
        });

        _.extend(msg, {
            status: res.ok ? '' : 'fail',
            status_msg: res.message
        }, _.pick(user, 'avatar', 'nick_name'));
        actions.edit(msg);

        onDidSendMsg && onDidSendMsg(msg, session);
        cfg.cb && cfg.cb(msg, session);
    }

    onKeyDown(ev) {
        if (!ev.shiftKey && ev.keyCode === 13) { //Enter
            ev.preventDefault();

            this.onSend(ev);
        }
    }

    onSend(ev) {
        let inputEl = this.refs.input;
        let content = inputEl.value.trim();

        content && this.sendMsg({
            content: content
        }, {
            cb() {
                inputEl.value = "";
            }
        });
        this.noBubble(ev);
    }

    onUpProgress(file, percentage) {
        const { user, actions } = this.props;

        let msg = this.findMsgByFile(file.id);
        if (!msg) {
            msg = this.createMsg({
                body: {
                    type: 'uploading',
                    file_id: file.id,
                    file_name: file.name,
                    file_size: file.fmt_size,
                    file_src: file.src,
                    file_ext: file.ext,
                    percentage: percentage
                }
            });
        } else {
            msg.body.percentage = percentage;
        }

        _.extend(msg, _.pick(user, 'avatar', 'nick_name'));
        actions.addOrEdit(msg);
    }

    onUpSuccess(file) {
        let msg = this.findMsgByFile(file.id);

        delete msg.body.file_id;
        delete msg.body.percentage;

        _.extend(msg.body, {
            type: file.fmt_type,
            file_src: file.src,
            storage_policy: file.storage_policy
        });
        console.log('onUpSuccess--', msg)
        this.sendMsg(msg);
    }

    onUpError(file, data) {
        // let msg = this.findMsgByFile(file.id);
        // _.extend(msg.body, {
        //     type: file.type,
        //     file_src: file.src,
        //     status: 'fail',
        //     status_msg: '上传失败'
        // });
        // this.sendMsg(msg);
    }

    handleClickUploaderBtn(ev) {
        this.setState({
            pickFlag: true
        });
        this.noBubble(ev);
    }

    handleUploadFinished() {
        this.setState({
            pickFlag: false
        })
    }
    async handleCapture(params) {
        console.log("handleCapture");
        let that = this;
        let res = await fetch(urls.api.upolad_token);
        if (res.ok) {
            that.setState({
                isShowImgThumbPreview: true,
                imgThumbPreviewSrc: params.src,
                fnSubmitThumbImg: function(next) {
                    sendAliBase64({
                        config: res.upload,
                        _data: params.src,
                        data: params.content,
                        success(res){
                            console.log(res)
                            let { file, cfg } = res || {};
                            const { user, session } = that.props;
                            let msg = that.createMsg({
                                    body: {
                                        type: 'image',
                                        file_name: file.name,
                                        file_size: file.fmt_size,
                                        file_src: cfg.url,
                                        file_ext: file.ext,
                                    }
                                });
                           
                            that.sendMsg(msg);
                            that._removeThumb();
                        },
                        complete: next
                    })
                },
                fnCancelThumbImg: function() {
                    that._removeThumb();
                }
            })
        } 
    }
    _removeThumb() {
        this.setState({
            imgThumbPreviewSrc: '',
            isShowImgThumbPreview: false
        })
    }

    manualUpload(instance, file, cb) { //粘贴,截图，拖拽需手动上传
        if (this.state.pickFlag || !isImg(file.type)) {
            return cb && cb()
        }
        let that = this;
        try {
            instance.makeThumb(file, function(error, src) {
                that.setState({
                    isShowImgThumbPreview: true,
                    imgThumbPreviewSrc: src,
                    fnSubmitThumbImg: function(next) {
                        cb && cb();
                        next && next();
                        that._removeThumb();
                    },
                    fnCancelThumbImg: function() {
                        instance.cancelFile(file);
                        that._removeThumb();
                    }
                })
            }, 1, 1);
        } catch (ex) {
            that._removeThumb();
            return cb && cb();
        }
    }

    render() {
        const { rows = 5 } = this.props;

        let className = mixinsClassName("msg-editor", this.props.className);
        // let imgThumbPreviewSrc = `${urls.imageRoot}group.png`;
        // let isShowImgThumbPreview = true;
        return (
            <div id="msg-editor-box" className={className} onClick={()=>{this.refs.input.focus();}}>
                {
                    this.state.isShowImgThumbPreview ? <ImgThumbPreview imgThumbPreviewSrc={this.state.imgThumbPreviewSrc} onCancelThumbImg={this.state.fnCancelThumbImg} onSubmitThumbImg={this.state.fnSubmitThumbImg}/> : null
                }
                <Toolbar>
                    <Uploader 
                        onClick={this.handleClickUploaderBtn.bind(this)} 
                        onProgress={this.onUpProgress.bind(this)} 
                        onSuccess={this.onUpSuccess.bind(this)}
                        onError={this.onUpError.bind(this)}
                        onFinshed={this.handleUploadFinished.bind(this)}
                        manualUpload={this.manualUpload.bind(this)}
                    >
                        <a className="icon icon-upload"></a>
                    </Uploader>
                    <Capture onCaptureAction={this.handleCapture.bind(this)}/>
                </Toolbar>
                <textarea ref="input" 
                        className="scroll-y" 
                        rows={rows} 
                        onKeyDown={this.onKeyDown.bind(this)}>
                </textarea>
                <Footbar className="pull-right">
                    <span className="text-muted font-xs">发送按Shift+Enter换行，按Enter发送</span>
                    <Button bsStyle="primary" className="mgl-xs" onClick={this.onSend.bind(this)}>发送</Button>
                </Footbar>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/msg/editor.js